import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotifificationE } from '../../../Enum/notifications.enum';
import { NotificationI } from '../../../interfaces/notifications/notification.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { MessageService } from '../../../services/message.service';
import { NotificationsService } from '../../../services/notifications.service';

@Component({
  selector: 'app-user-notifications-modal',
  templateUrl: './user-notifications-modal.component.html',
  styleUrls: ['./user-notifications-modal.component.scss']
})
export class UserNotificationsModalComponent implements OnInit {

  @Input() user: UserI;
  @Output() notificationSubmit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  public notificationsUsr: NotificationI[];
  public loadingNotifications = false;
  sendingNoti = false;

  constructor(
    private messageService: MessageService,
    private notificationServ: NotificationsService,
  ) {
  }

  ngOnInit(): void {
    this.loadNotificationsUsr();
  }

  loadNotificationsUsr() {
    this.loadingNotifications = true;

    this.notificationServ.getUserNotifications(this.user.id).subscribe(res => {
      if (res.ok === true) {
        this.notificationsUsr = res.notifications;
      }
      this.loadingNotifications = false;
    }, error => {
      this.loadingNotifications = false;
      console.log(error);
    });
  }

  async sendNotification() {

    const {value: notificacion} = await this.messageService.confirmNotification(this.user);

    if (notificacion && notificacion.length > 0) {
      this.sendingNoti = true;
      let data = {
        notifications: [
          {
            user_id: this.user.id,
            message: notificacion[1].message,
            type: notificacion[0].type
          }
        ]
      }

      this.notificationServ.sendNotifications(data).subscribe(res => {
        if (res.ok === true) {
          this.messageService.printStatus(res.message, 'success');
          this.loadNotificationsUsr();
        }
      }, error => {
        this.messageService.printStatusArray(error.error.errors, 'error');
        console.log(error);
      });
    }
  }

  onClose() {
    this.closeModal.emit();
  }

}
